<template>
  <div class="price-info-container">
    <div v-if="showRent || showFtRent" class="price-info is-rent">
      <span v-if="stock.negorent === '1'">
        {{ $t('find.FOR_LEASE_S') }} {{ $t('find.NEGOTIABLE') }}
      </span>
      <span v-else-if="showRent && !showFtRent">
        {{ $t('find.FOR_LEASE_S') }} ${{ fmt(parseInt(stock.rent)) }}{{ accuracyText(stock.rent_accuracy) }}
      </span>
      <span v-else-if="!showRent && showFtRent">
        {{ $t('find.FOR_LEASE_S') }} @${{ fmt(parseInt(stock.ft_rent)) }}{{ accuracyText(stock.ft_rent_accuracy) }}
      </span>
      <span v-else>
        {{ $t('find.FOR_LEASE_S') }} ${{ fmt(parseInt(stock.rent)) }} @${{ fmt(parseInt(stock.ft_rent)) }}
      </span>
    </div>
    <div v-else class="price-info">&nbsp;</div>
    <div v-if="showSell || showFtSell" class="price-info is-sell">
      <span v-if="stock.negoprice === '1'">
        {{ $t('find.FOR_SALE_S') }} {{ $t('find.NEGOTIABLE') }}
      </span>
      <span v-else-if="showSell && !showFtSell">
        {{ $t('find.FOR_SALE_S') }} ${{ formatBigNumber(parseInt(stock.price)) }}{{ accuracyText(stock.price_accuracy) }}
      </span>

      <span v-else-if="!showSell && showFtSell">
        {{ $t('find.FOR_SALE_S') }} @${{ fmt(parseInt(stock.ft_sell)) }}{{ accuracyText(stock.ft_sell_accuracy) }}
      </span>
      <span v-else>
        {{ $t('find.FOR_SALE_S') }} ${{ formatBigNumber(parseInt(stock.price)) }} @${{ fmt(parseInt(stock.ft_sell)) }}
      </span>
    </div>
  </div>
</template>

<script>
import numberFormatMixin from '@/mixins/numberFormat';

export default {
  props: ['stock'],
  mixins: [numberFormatMixin],
  data() {
    return {

    };
  },
  computed: {
    showSell() {
      if (this.stock.negoprice === '1') {
        return true;
      }
      return (this.stock.tx_type === 'B' || this.stock.tx_type === 'S') &&
        !isNaN(parseInt(this.stock.price, 10)) && parseInt(this.stock.price, 10) > 0;
    },
    showRent() {
      if (this.stock.negorent === '1') {
        return true;
      }
      return (this.stock.tx_type === 'B' || this.stock.tx_type === 'L') &&
        !isNaN(parseInt(this.stock.rent, 10)) && parseInt(this.stock.rent, 10) > 0;
    },
    showFtSell() {
      if (this.stock.ics_type === 's') {
        return false;
      }

      return (this.stock.tx_type === 'B' || this.stock.tx_type === 'S') &&
        this.stock.ft_sell && this.stock.ft_sell > 0;
    },
    showFtRent() {
      if (this.stock.ics_type === 's') {
        return false;
      }

      return (this.stock.tx_type === 'B' || this.stock.tx_type === 'L') &&
        this.stock.ft_rent && this.stock.ft_rent > 0;
    },
  },
  methods: {
    accuracyText(accuracy) {
      if (accuracy === 'above') {
        return this.$t('stock_info.PRICE_ACCURACY_ABOVE');
      }

      if (accuracy === 'about') {
        return this.$t('stock_info.PRICE_ACCURACY_ABOUT');
      }

      if (accuracy === 'about_above') {
        return this.$t('stock_info.PRICE_ACCURACY_ABOUT_ABOVE');
      }

      return '';
    },
  },
};
</script>

<style scoped>
.price-info-container {
  font-size: 1.2rem;  
  display: flex;
  flex-flow: row;
  align-items: flex-end;
}

.price-info {  
  padding: 2px 0;
}

.price-info:nth-child(2) {
  margin-left: 10px;
}

.price-info .is-s {
  margin-bottom: 0;
}

.price-info > span {
  border-radius: 5px;
  color: #ffffff;
  padding: 2px 4px;
}

.is-sell > span {
  background-color: #FF150D;
}

.is-rent > span {
  background-color: #00BEB5;
}

@media (max-width: 991px) {
  .price-info-container {
    flex-flow: column;
  }
  
  .price-info:nth-child(2) {
    margin-top: 8px;
  }
}

@media (max-width: 768px) {
  .price-info-container {
    height: 62px;
  }
}
</style>